var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { ActivityValidationLevels } from 'common/enums/activity/activity-validation-levels.enum';
import { useTranslation } from 'react-i18next';
var ActivityValidationLevelSelect = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'validationLevel' : _b, value = _a.value, _c = _a.label, label = _c === void 0 ? 'Уровень валидации' : _c, handleChange = _a.handleChange, className = _a.className, addAll = _a.addAll;
    var t = useTranslation().t;
    return (_jsxs(FormControl, __assign({ className: className }, { children: [_jsx(InputLabel, { children: label }, void 0), _jsx(Select, __assign({ required: true, value: value, onChange: function (_event, value) {
                    if (value) {
                        handleChange(name, value.props.value);
                    }
                }, label: t(label), input: _jsx(OutlinedInput, { className: "dark:text-white", label: t(label) }, void 0), sx: {
                    height: '56px',
                    '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center'
                    }
                } }, { children: __spreadArray([
                    ActivityValidationLevels.Base,
                    ActivityValidationLevels.SportEvent
                ], (addAll === true ? ['ALL'] : []), true).map(function (v) {
                    return (_jsx(MenuItem, __assign({ value: v }, { children: t(v) }), v));
                }) }), void 0)] }), void 0));
};
export default ActivityValidationLevelSelect;
